const state = {
	news: '',
}
export default state


// WEBPACK FOOTER //
// ./src/store/modules/state.js